import React from 'react';
import { Box, TextField, Typography, Grid } from '@mui/material';
import { LocationOn as LocationIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PlacesAutocomplete from '../../PlacesAutocomplete';

interface AddressFieldsSectionProps {
  addressInput: string;
  onAddressInputChange: (value: string) => void;
  onPlaceSelect: (place: any) => void;
  formData: {
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    state_province?: string;
    postal_code?: string;
    country?: string;
  };
  onChange: (field: string, value: string) => void;
  isValid: boolean;
}

const AddressFieldsSection: React.FC<AddressFieldsSectionProps> = ({
  addressInput,
  onAddressInputChange,
  onPlaceSelect,
  formData,
  onChange,
  isValid,
}) => {
  const { t } = useTranslation('profile');
  
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocationIcon />
        {t('businessProfile.address.title')}
      </Typography>
      <PlacesAutocomplete
        value={addressInput}
        onChange={onAddressInputChange}
        onPlaceSelect={onPlaceSelect}
        placeholder={t('businessProfile.address.searchPlaceholder')}
      />

      {/* Address Fields - Inline */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={t('businessProfile.address.addressLine1')}
            value={formData.address_line_1 || ''}
            onChange={(e) => onChange('address_line_1', e.target.value)}
            required
            error={!isValid && !formData.address_line_1?.trim()}
            helperText={!isValid && !formData.address_line_1?.trim() ? t('businessProfile.address.addressLine1Required') : ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={t('businessProfile.address.addressLine2')}
            value={formData.address_line_2 || ''}
            onChange={(e) => onChange('address_line_2', e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label={t('businessProfile.address.city')}
            value={formData.city || ''}
            onChange={(e) => onChange('city', e.target.value)}
            required
            error={!isValid && !formData.city?.trim()}
            helperText={!isValid && !formData.city?.trim() ? t('businessProfile.address.cityRequired') : ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label={t('businessProfile.address.stateProvince')}
            value={formData.state_province || ''}
            onChange={(e) => onChange('state_province', e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            label={t('businessProfile.address.postalCode')}
            value={formData.postal_code || ''}
            onChange={(e) => onChange('postal_code', e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label={t('businessProfile.address.country')}
            value={formData.country || ''}
            onChange={(e) => onChange('country', e.target.value)}
            required
            error={!isValid && !formData.country?.trim()}
            helperText={!isValid && !formData.country?.trim() ? t('businessProfile.address.countryRequired') : ''}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddressFieldsSection;

